<template>
  <div v-loading="loading"
       element-loading-text="拼命加载中">
    <el-form class="search-box" ref="form" :model="form" :rules="rules">
      <el-form-item prop="order_number">
        <el-input
          ref="search"
          @focus="stopKeyborad"
          @blur="stopKeyborad"
          v-model="form.order_number"
          @keydown.enter.native.prevent="onSubmit"
          placeholder="扫描订单编号"
        >
          <el-button
            @click.prevent="onSubmit"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-row :gutter="6"  v-if="items.length>0">
     <el-col :span="18">
       <div>

         <div>
           <span style="font-weight: bold">订单编号: </span>{{ items[0].order_number }}
         </div>
         <div><span style="font-weight: bold">交易编号: </span>{{ items[0].transaction_no }}</div>

       </div>
     </el-col>
     <el-col :span="6" v-if="partition_name">
       {{partition_name}} 区
     </el-col>
    </el-row>

    <template v-for="item of items">

      <div
          class="show"
          :class="{'not_click':(item.status == 4||item.status == 5) }"
          :key="item.id"
          @click=" ( item.status != 8 && item.status != 4 && item.status != 5 && select(item) ) || item.status == 5 && scrappedOrder(item) "
      >
        <div class="line">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple-light" style="color: #3967FF">
                <p v-if="item.purchase !== null">采购单号: {{ item.purchase.purchase_no }}</p>
                <p v-else>采购单号: 待补货</p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light" style="color: #3967FF">
                <p>采购员: {{ item.auth?item.auth.username:'' }}</p>
              </div>
              <div v-if="item.status===4" class="status_tips">锁单</div>
              <div v-else-if="item.status===5" class="status_tips">作废</div>
              <div v-else-if="item.status===8" class="status_tips">报废</div>
              <div v-else-if="item.pid != null " class="status_tips">补货</div>
              <div v-else-if="item.status===6 && item.arrival_quantity < item.quantity " class="status_tips">缺货</div>
              <div v-else-if="item.status===6 && item.arrival_quantity >= item.quantity" class="status_tips">待上架</div>


              <div v-else-if="item.show_note!==null&&item.status != 1" class="status_tips">改</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple"
                   style="color: #bd2c00">
                <h3>多品编号</h3>
                <p>{{ item.transaction_number }}</p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <h3>SKU</h3>
                <p>{{ item.sku }}</p>
              </div>
            </el-col>
            <div v-if="item.status == 6 || (item.quantity - item.arrival_quantity - item.abnormal_quantity) != item.quantity ">
              <el-col :span="6">
                <div class="grid-content bg-purple-light">
                  <h3>数量</h3>
                  <p style="color:  #bd2c00">{{ item.quantity }}</p>
                </div>
              </el-col>
              <el-col :span="6" v-if="item.arrival_quantity!==null">
                <div class="grid-content bg-purple-light">
                  <h3>待验收数量</h3>
                  <p style="color:  #bd2c00">{{ item.quantity - item.arrival_quantity - item.abnormal_quantity}}</p>
                </div>
              </el-col>
              <el-col :span="6" v-if="item.arrival_quantity!==null">
                <div class="grid-content bg-purple-light">
                  <h3>异常数</h3>
                  <p style="color:  #bd2c00">{{ item.abnormal_quantity }}</p>
                </div>
              </el-col>
              <el-col :span="6" v-if="item.arrival_quantity!==null">
                <div class="grid-content bg-purple-light">
                  <h3>验收数</h3>
                  <p style="color:  #bd2c00">{{ item.arrival_quantity }}</p>
                </div>
              </el-col>
            </div>
            <div v-else>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <h3>数量</h3>
                  <p style="color:  #bd2c00">{{ item.quantity }}</p>
                </div>
              </el-col>
            </div>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <h3>商品中文名称</h3>
                <p>{{ item.product_name }}</p>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-light">
                <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{ item.word }}</span></p>
              </div>
            </el-col>
            <el-col :span="24" v-if="item.remark!==null">
              <div class="grid-content bg-purple-light">
                <p>备注: {{ item.remark }}</p>
              </div>
            </el-col>
            <el-col :span="24" v-if="item.shelf_id!==null">
              <div class="grid-content bg-purple-light" style="color: #3967FF">
                <p>货架号: {{ item.shelf.shelf_no }}</p>
              </div>
            </el-col>

            <template v-else>
              <el-col :span="24" v-if="item.history_shelf_id!==null">
                <div class="grid-content bg-purple-light" style="color: #3967FF">
                  <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                </div>
              </el-col>
            </template>

            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
                <p v-else-if="item.status===5">状态: <span style="color: #94971b">作废</span></p>
                <p v-else-if="item.status===6">状态: <span style="color: #eb0fd9">缺货</span></p>
                <p v-else-if="item.status===7">状态: <span style="color: #f00">删除</span></p>
                <p v-else-if="item.status===8">状态: <span style="color: #123723">报废</span></p>
                <p v-else>状态: 其它</p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light" style="color: #3967FF">
                <div  style="color: #3967FF">
                  <p v-if=" item.sub_table && item.sub_table.country != null ">国家: {{ item.sub_table.country }} </p>
                  <p v-else>国家: 无</p>
                </div>
              </div>
            </el-col>
            <el-col :span="24" v-if="item.accept_at">
              <div class="grid-content bg-purple-light">
                <p>时间: {{ item.accept_at }} </p>
              </div>
              <div class="status_card" v-if="card_status == 0">有卡片</div>
              <div class="status_card" v-else-if="card_status == 8">已拣卡</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </template>

    <!--旧产品-->
    <el-collapse style="margin-top: 30px" v-if="old_order.length>0">
      <el-collapse-item>
        <template slot="title">
          旧产品信息<div class="old-count">{{old_order.length}}</div>
        </template>
        <template v-for="item of old_order">
          <div class="show" :key="item.id">
            <div class="line">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light" style="color: #3967FF">
                    <p v-if="item.purchase !== null">采购单号: {{ item.purchase.purchase_no }}</p>
                    <p v-else>采购单号: 待补货</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple"
                       style="color: #bd2c00">
                    <h3>多品编号</h3>
                    <p>{{ item.transaction_number }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <h3>数量</h3>
                    <p style="color:  #bd2c00">{{ item.quantity }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <h3>SKU</h3>
                    <p>{{ item.sku }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <h3>商品中文名称</h3>
                    <p>{{ item.product_name }}</p>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light">
                    <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{ item.word }}</span></p>
                  </div>
                </el-col>
                <el-col :span="24" v-if="item.remark!==null">
                  <div class="grid-content bg-purple-light">
                    <p>备注: {{ item.remark }}</p>
                  </div>
                </el-col>
                <el-col :span="24" v-if="item.shelf_id!==null">
                  <div class="grid-content bg-purple-light" style="color: #3967FF">
                    <p>货架号: {{ item.shelf.shelf_no }}</p>
                  </div>
                </el-col>

                <template v-else>
                  <el-col :span="24" v-if="item.history_shelf_id!==null">
                    <div class="grid-content bg-purple-light" style="color: #3967FF">
                      <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                    </div>
                  </el-col>
                </template>

                <el-col :span="24">
                  <div class="grid-content bg-purple-light">
                    <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                    <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                    <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                    <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                    <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
                    <p v-else-if="item.status===5">状态: <span style="color: #94971b">作废</span></p>
                    <p v-else-if="item.status===6">状态: <span style="color: #eb0fd9">缺货</span></p>
                    <p v-else-if="item.status===7">状态: <span style="color: #f00">删除</span></p>
                    <p v-else-if="item.status===8">状态: <span style="color: #123723">报废</span></p>
                    <p v-else>状态: 其它</p>
                  </div>
                </el-col>
                <el-col :span="24" v-if="item.accept_at">
                  <div class="grid-content bg-purple-light">
                    <p>时间: {{ item.accept_at }} </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </template>
      </el-collapse-item>
    </el-collapse>


<!--    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="90%"
      top="30vh"
      :close-on-click-modal="false"
      center>
      <span>该订单货已到齐,是否标记为已拣货？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancelDialog">取 消</el-button>
    <el-button style="margin-left: 50px" type="primary" @click="removeShelf">标记</el-button>
  </span>
    </el-dialog>-->

  </div>
</template>

<script>
// import {mapState,mapMutations} from 'vuex';
// import Bus from '@/assets/js/bus';
export default {
  name: "Check",
  data() {
    return {
      card_status:-1,
      // centerDialogVisible: false,
      // lock_shelf:"",
      remove_order: '',
      loading: false,
      form: {
        order_number: ""
      },
      rules: {
        order_number: [
          {required: true, message: "请扫描订单编号", trigger: "blur"},
          /*{
            type: "number",
            message: "请输入正确的订单编号",
            trigger: ["blur", "change"],
          },*/
        ],
      },
      items: {},
      old_order:{},

      bus_item: {}

    }
  },
  methods: {
    //报废处理
    scrappedOrder(item){
      var _this = this;
      this.$confirm('是否报废此采购单产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        customClass:'old-order-select',
        closeOnClickModal:false,
      }).then(() => {
        //对订单进行报废处理
        let param = {
          id: item.id,
          status: 8,
        }
        _this.http.fetchPost(_this.api.check, param).then((res) => {
          console.log(res)
          let data = res.data
          if (data.code === 200) {
            const h = this.$createElement;
            _this.$message({
              offset: 50,
              duration: 1000,
              message: h('p', null, [
                h('span', null, '提交成功 '),
                // h('i', { style: 'color: teal' }, 'VNode')
              ])
            });
            setTimeout(function () {
              _this.form.order_number = item.order_number;
              _this.onSubmit();

            }, 1000)

          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消报废'
        });
      });
    },
    // ...mapMutations(['setShelf']),
    select(item) {
      item.partition_name = this.partition_name
      // item.lock_shelf = this.lock_shelf
      item.purchase_no = item.purchase.purchase_no

      item.card_status = this.card_status
      // item.shelf_off = this.shelf_off

      this.bus_item = item
      // this.$EventBus.$emit('order', item);
      this.$router.push({
        path: '/detail',
        // query: item
      })

    },
    onSubmit() {

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.http.fetchGet(this.api.product + "/1/" + this.form.order_number).then((res) => {
            // this.loading = false
            var data = res.data;
            console.log(data)
            if (data.code === 200) {
              //标记未下全单提示
              if(!data.data.finish_purchase_bool){
                this.$alert('该订单未下全单！！请勿发货', '提示', {
                  confirmButtonText: '确定',
                  customClass:'alt_css'
                });
              }
              this.card_status = data.data.card_status;
              // let lists = data.data;

              //对数组进行重组排序
              var status_0 = [];
              var status_6 = [];
              var status_other = [];
              for(var i in data.data.products){
                if(data.data.products[i]['status'] == 0){
                  status_0.push(data.data.products[i])
                }else if(data.data.products[i]['status'] == 6){
                  status_6.push(data.data.products[i])
                }else{
                  status_other.push(data.data.products[i])
                }
              }
              status_0 = status_0.concat(status_6);
              status_0= status_0.concat(status_other);
              this.items = status_0
              this.old_order = data.data.old_order
              this.remove_order = this.form.order_number
              this.form.order_number = ""
              this.onfocusEvent()

              //更改地址参数
              const query=JSON.parse(JSON.stringify(this.$route.query))
              query.order_number=this.items[0].order_number
              this.$router.push({ path: this.$route.path, query })

              if (
                  this.items.length === 1 &&
                  this.items[0].status !== 4 &&
                  this.items[0].status !== 5 &&
                  this.items[0].status !== 6 &&
                  this.items[0].status !== 8
              ) {
                this.select(this.items[0])
              }
              /*else {
                //提示标记发货弹窗
                this.openDialog()
              }*/

            } else {
              this.$message.error(data.message);
              this.form.order_number = ""
              this.onfocusEvent()
            }

            this.loading = false
            // 请求成功处理
          }).catch((err) => {
            console.log(err);
            this.form.order_number = ""
            this.onfocusEvent()
            this.$message.error('扫描订单号错误');
            this.loading = false
          });
        } else {
          // this.$message.error('请输入账号和密码');
          console.log("error submit!!");
          return false;
        }
      });

    },

    //更新列表数据
    refresh(number) {
      this.http.fetchGet(this.api.product + "/1/" + number).then((res) => {
        // this.loading = false
        var data = res.data;

        console.log(data)
        if (data.code === 200) {
          this.card_status = data.data.card_status;
          console.log(this.card_status);
          // let lists = data.data;
          // console.log(shops);
          this.remove_order = number

          //对数组进行重组排序
          var status_0 = [];
          var status_6 = [];
          var status_other = [];
          for(var i in data.data.products){
            if(data.data.products[i]['status'] == 0){
              status_0.push(data.data.products[i])
            }else if(data.data.products[i]['status'] == 6){
              status_6.push(data.data.products[i])
            }else{
              status_other.push(data.data.products[i])
            }
          }
          status_0 = status_0.concat(status_6);
          status_0= status_0.concat(status_other);
          this.items = status_0
          this.old_order = data.data.old_order
          this.form.order_number = ""
          this.onfocusEvent()
          //提示标记发货弹窗
          /*if (this.items.length > 1) {
            this.openDialog()
          }*/

        } else {
          this.$message.error(data.message);
          this.form.order_number = ""
          this.onfocusEvent()
        }

        // this.loading = false
        // 请求成功处理
      }).catch((err) => {
        console.log(err);
        this.form.order_number = ""
        this.onfocusEvent()
        // this.loading = false
      });
    },

    /*openDialog(){
      //提示标记发货弹窗
      let open=true;
      for (let i = 0; i < this.items.length; i++) {
        console.log(this.items[i])
        if (this.items[i].status !== 1) {
          open=false;
          break;
        }
      }

      if (open) {
        this.centerDialogVisible=true
      }
    },*/

    /*cancelDialog(){
      this.centerDialogVisible=false
      this.onfocusEvent()
    },*/

    //自动获取光标
    onfocusEvent() {
      this.$refs.search.focus()
    },
    stopKeyborad(e) {
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },
    /*removeShelf() {
      this.centerDialogVisible=false
      this.loading=true
      this.http.fetchDel(this.api.removeShelf + "/" + this.remove_order).then((res) => {
        var data = res.data
        if (data.code === 200) {
          this.$message.success("标记已拣货成功")
          this.refresh(this.remove_order)
          this.loading=false
        }
      }).catch(err => {
        console.log(err)
      })
    }*/
  },
  computed: {

    //货架分区
    partition_name() {
      if (this.items.length > 0) {
        for (let item of this.items) {
          if (item.partition != null) {
            return item.partition.name
          }
        }
      }else if(this.old_order.length>0){
        for (let item of this.old_order) {
          if (item.partition != null) {
            return item.partition.name
          }
        }
      }

      return null
    }

    /*lock_shelf() {
      for (let item of this.items) {
        if (item.shelf_id != null) {
          return item.shelf_id
        }
      }
      return null
    },*/
    /*shelf_off() {
      if (this.items.length === 1) {
        return 1;
      } else {
        return 0;
      }

    }*/
  },
  /*watch: {
    $route: { // 监听路由的参数变化
      handler() { // 数据变化更新数据
        var instId = this.$route.query.order_number
        if (instId !== undefined) {
          this.refresh(instId)
        }
      },
      immediate: true // 立即执行
    }
  },*/

  /*beforeDestroy() {
    this.$EventBus.$emit('order', this.bus_item);
  },*/

  //被 keep-alive 缓存的组件失活时调用
  deactivated(){
    this.$EventBus.$emit('order', this.bus_item);
  },

  //被 keep-alive 缓存的组件激活时调用
  activated(){
    // console.log(23456)
    this.onfocusEvent()

    var instId = this.$route.query.order_number
    if (instId !== undefined) {
      this.refresh(instId)
    }

  },
  /*mounted() {
    // alert(123)
    this.onfocusEvent()
  }*/

}
</script>

<style scoped lang="stylus">
.not_click{
  background-color: #e8e8e8;
}
.status_tips{
  position: absolute;
  color: red;
  top: 2px;
  right: 17px;
  border: 1px solid red;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;
  font-size: 28px;
}
.status_card{
  position: absolute;
  color: red;
  bottom: 5px;
  right: 17px;
  border: 1px solid red;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;
  font-size: 28px;
}
.show {
  //float: left;
  width: 100%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 99%;

    .el-col {
      margin-top 5px
      margin-bottom: 5px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.old-count
  margin-left: 5px;
  width: 20px;
  height: 20px;
  background-color: #ea4444;
  line-height: 20px;
  text-align: center;
  color: white;
  border-radius: 10px

@media (max-width: 720px) {


}

</style>
